import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from '../reducers/colors';
import { Color } from 'lib/modelBuilder/entities/Color';

/**
 * Direct selector to the app state domain
 */

const selectColorsDomain = (state: ApplicationRootState) => {
  if (state.configurator) {
    return state.configurator.colors || initialState;
  }
  return initialState;
};

const makeSelectIsColorsLoading = () =>
  createSelector(selectColorsDomain, (substate): boolean => substate.loading);

const makeSelectIsColorsReady = () =>
  createSelector(selectColorsDomain, (substate): boolean => !!substate.data);

const makeSelectColors = () =>
  createSelector(selectColorsDomain, (substate): Color[] => {
    if (substate.data) return substate.data;
    return [];
  });

export const makeSelectColor = (reference: string) =>
  createSelector(selectColorsDomain, (substate): Color | undefined => {
    if (substate.data)
      return substate.data.find(e => e.reference === reference);
    return undefined;
  });

export {
  selectColorsDomain,
  makeSelectColors,
  makeSelectIsColorsLoading,
  makeSelectIsColorsReady,
};
